<template>
      <v-layout row wrap justify-center align-center>
          <v-flex xs12>
            <fade-transition :duration="600">
             <v-card class='mb-2'>
                  <v-card-title class="ml-4">
                    <v-flex xs10 justify-center align-center class='text-xs-center'> 
                      <h1>{{empresaData.name}}
                        
                      </h1>
                    </v-flex>
                    <v-flex xs2 v-if="editing">
                      <v-icon
                        v-if="permissao"
                        size="25"
                        @click="dialog = true"
                        style="float: right" 
                      >
                        delete
                      </v-icon>                      
                    </v-flex>
                    <v-flex xs6 justify-start>
                      <profile-text title="Logradouro :" v-model='empresaData.logradouro'
                        :last='true'
                        :editing='editing'
                        input-type='multilinetext'></profile-text>
                      <profile-text title="Número :" v-model='empresaData.numero'
                        :last='true'
                        :editing='editing'
                        input-type='multilinetext'></profile-text>
                      <profile-text title="Complemento :" v-model='empresaData.complemento'
                        :last='true'
                        :editing='editing'
                        input-type='multilinetext'></profile-text>
                      <profile-text title="Número de licenças :" v-model='empresaData.licencas'
                        :last='true'
                        :editing='editing'
                        input-type='multilinetext'></profile-text>
                    </v-flex>
                    <v-flex xs6 justify-start>
                      <profile-text title="CEP :" v-model='empresaData.cep'
                        :last='true'
                        :editing='editing'
                        input-type='multilinetext'></profile-text>
                      <profile-text title="Bairro :" v-model='empresaData.bairro'
                        :last='true'
                        :editing='editing'
                        input-type='multilinetext'></profile-text>
                      <profile-text title="Cidade :" v-model='empresaData.cidade'
                        :last='true'
                        :editing='editing'
                        input-type='multilinetext'></profile-text> 
                        <profile-text title="Tipo :" v-model='tipo'
                        :last='true'
                        input-type='multilinetext'></profile-text> 
                        <profile-text title="Situação :" v-model='situacao'
                        :last='true'
                        v-if="!editing"
                        input-type='multilinetext'></profile-text>
                        <br>
                        <h3 v-if="editing" >Deseja Bloquear?</h3> 
                        <v-switch
                        v-if="editing"
                        v-model="empresaData.flag_bloqueado"
                        color="red"
                        label="Bloquear?"></v-switch>
                    </v-flex>
                    <v-flex xs6>
                      <div style="height: 1rem"></div>  
                      
                      <div v-if="!editing">                    
                        <p>
                          <strong style="font-size: 1.2rem">Responsavel : </strong>
                          <v-chip
                            v-if="empresaData.responsavel"  
                            desable 
                            color='blue'
                            outline>
                                {{empresaData.responsavel}}
                          </v-chip>
                        </p>
                      </div>
                      <div v-if="editing">
                        <p>
                          <strong style="font-size: 1.2rem">Responsavel : </strong>
                        </p>
                        <v-autocomplete
                          :items="usuario"
                          v-model="responsavel"
                          label="Selecione o responsável"
                          item-text="username"
                          return-object
                          chips
                          max-height="auto"
                          style="width: 94%"
                        > </v-autocomplete>
                      </div>

                    </v-flex>
                          
                      
                      
                  </v-card-title>
                   <v-btn
                      v-if="this.$store.state.selectedRole.name === 'Admin'|| $store.state.user.is_superuser === true"
                      absolute
                      dark
                      fab
                      bottom
                      right
                      color="blue"
                      @click="pressFloatingButton()"
                      >
                      <v-icon v-if='!editing'>mode_edit</v-icon>
                      <v-icon v-else>done</v-icon>
                    </v-btn>  
              </v-card>
            </fade-transition>
          </v-flex>
          <v-dialog v-model="dialog" persistent max-width="290">
            <v-card>
              <v-card-title class="headline">Deseja deletar?</v-card-title>
              <v-card-text>Gostaria excluir essa turma?</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" flat @click.native="dialog = false">Cancelar</v-btn>
                <v-btn color="green darken-1" flat @click.native="excluir()">Deletar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
      </v-layout>
</template>

<script>

import api from '@/api'
import ProfileText from '@/components/reusable/ProfileText.vue'
import { FadeTransition } from 'vue2-transitions'
export default {
  components: {
    ProfileText,
    FadeTransition
  },
  data () {
    return {
      empresaData: {
        parent: '',
        responsavel: ''
      },
      currentTab: 'Sobre',
      showImageUpload: false,
      imageChangeModal: false,
      editing: false,
      avaliando: false,
      dialog: false,
      tempData: {},
      options: {},
      usuario: {},
      admins: {},
      tipo: '',
      situacao: '',
      responsavel: [],
      evidencias: {},
      criterios: {},
      page: 1
    }
  },
  mounted () {
    var projectid = this.$route.params.id
    api.request('GET', 'companies/' + projectid + '/').then(response => {
      this.empresaData = response.data
      console.log(this.empresaData)
      if (response.data.responsavel !== null) {
        api.request('GET', 'users/' + response.data.responsavel + '/').then(resp => {
          this.responsavel = resp.data
          this.empresaData.responsavel = resp.data.username
          this.tipoContrato()
          this.bloqueado()
        })
      }
    })
    api.request('GET', 'search-user?groups__name=Admin&company__id=' + projectid).then((response) => {
      // this.usuario = response.data
      this.usuario = response.data
    })
  },
  watch: {
  },
  computed: {
    permissao () {
      return this.$store.state.user.is_superuser
    }
  },
  methods: {
    pressFloatingButton () {
      if (this.editing) {
        this.performSave()
      } else {
        this.editing = !this.editing
      }
    },
    tipoContrato () {
      if (this.empresaData.tipo === 'P') {
        this.tipo = 'Proprietário'
      }
      if (this.empresaData.tipo === 'M') {
        this.tipo = 'MakerLab'
      }
    },
    bloqueado () {
      console.log(this.empresaData.flag_bloqueado)
      console.log('bloquaosdh')
      if (this.empresaData.flag_bloqueado) {
        this.situacao = 'Bloqueado'
      } else {
        this.situacao = 'Regular'
      }
    },
    performSave () {
      var slugid = this.$route.params.id
      // if (this.empresaData.responsavel === null) {
      //   delete this.empresaData.responsavel
      // }
      console.log(this.responsavel.id)
      this.empresaData.responsavel = this.responsavel.id
      let self = this
      api
        .request('PATCH', 'companies/' + slugid + '/', this.empresaData)
        .then(function (response) {
          self.refreshUI()
          // console.log(response)
        })
    },
    excluir () {
      api.request('DELETE', 'companies/' + this.$route.params.id + '/').then(resp => {
        this.$router.push('/empresas')
      })
    },
    getUser (username) {
      var userarray = this.empresaData.integrantes.filter(value => {
        return value.username === username
      })
      return userarray[0]
    },
    refreshUI () {
      var projectid = this.$route.params.id
      api.request('GET', 'companies/' + projectid + '/').then(response => {
        this.empresaData = response.data
        this.tipoContrato()
        this.bloqueado()
        api.request('GET', 'users/' + response.data.responsavel + '/').then(resp => {
          this.responsavel = resp.data
          this.empresaData.responsavel = resp.data.username
          this.editing = false
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Empresas/Detail.vue